module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fKqDs"))).then(() => module.bundle.root('d0iPb'));